import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { waLink } from "@/lib/whatsapp";

const STEPS = [
    { num: "01", title: "Cerimônia", desc: "LC Cerimonial", testid: "timeline-step-cerimonia" },
    { num: "02", title: "Recepção", desc: "Música e ambientação", testid: "timeline-step-recepcao" },
    { num: "03", title: "Festa", desc: "DJ / Entretenimento", testid: "timeline-step-festa" },
    { num: "04", title: "Experiência", desc: "AstroLive", testid: "timeline-step-experiencia" },
];

const Timeline = () => (
    <section data-testid="timeline-section" className="bg-white px-6 md:px-12 py-28 md:py-40 border-t border-black/10">
        <div className="max-w-7xl mx-auto">
            <Reveal>
                <p className="text-[10px] tracking-[0.45em] uppercase text-[#6A2022] mb-8" data-testid="timeline-label">
                    Do Sim à Festa
                </p>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[0.95] tracking-tight max-w-4xl" data-testid="timeline-headline">
                    Do “sim” ao último{" "}
                    <span className="font-editorial italic font-light normal-case text-[#6A2022]">
                        hit da noite.
                    </span>
                </h2>
            </Reveal>

            <div className="mt-20 md:mt-28 grid md:grid-cols-4 gap-0">
                {STEPS.map((s, i) => (
                    <Reveal key={s.num} delay={i * 0.12}>
                        <div
                            data-testid={s.testid}
                            className="group border-l md:border-l-0 md:border-t border-black/10 pl-8 md:pl-0 md:pt-8 pb-12 md:pb-0 md:pr-10 relative"
                        >
                            <span className="absolute left-0 md:left-auto md:top-0 md:-translate-y-1/2 -translate-x-1/2 md:translate-x-0 w-2 h-2 rounded-full bg-[#6A2022] md:hidden" />
                            <span className="font-editorial italic font-light text-5xl md:text-6xl text-[#6A2022]">
                                {s.num}
                            </span>
                            <h3 className="mt-4 text-lg md:text-xl font-extrabold uppercase tracking-tight text-[#0A0A0A] group-hover:text-[#6A2022] transition-colors duration-300">
                                {s.title}
                            </h3>
                            <p className="mt-2 text-[11px] tracking-[0.25em] uppercase text-[#0A0A0A]/45">{s.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.3}>
                <div className="mt-20 md:mt-28 flex flex-col md:flex-row md:items-end md:justify-between gap-10 border-t border-black/10 pt-12">
                    <p className="font-editorial italic font-light text-2xl md:text-4xl text-[#6A2022] max-w-xl" data-testid="timeline-closing">
                        Um evento. Uma equipe. Uma experiência completa.
                    </p>
                    <a
                        href={waLink("geral")}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="timeline-cta"
                        className="inline-flex items-center justify-center gap-3 bg-[#0A0A0A] text-white px-8 py-4 text-[11px] tracking-[0.3em] uppercase font-semibold transition-colors duration-300 hover:bg-[#6A2022] shrink-0"
                    >
                        Montar meu evento
                        <ArrowUpRight className="w-4 h-4" />
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Timeline;
